import { Store } from 'redux';
import { setEventEmitter } from './eventEmitters';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import { eventHandlerCreators } from './handlerCreators';
import { ClientAPIEventNames } from './events';

declare global {
    interface Window {
        mmClientApi?: Array<any> | { push: (eventName: string, params: any) => void };
        __mmClientApiSubscriptions__?: Map<string, any>;
    }
}

const isNewChunk = (index: number, chunkSize: number) => index % chunkSize === 0;

const getSubscribedEventsInChuncks = (items: any[], chunkSize: number) => {
    let currentChunk: any[] = [];
    return items.reduce((chunks: any[][], item, index) => {
        if (isNewChunk(index, chunkSize)) {
            currentChunk = [item];
            chunks.push(currentChunk);
        } else {
            currentChunk.push(item);
        }
        return chunks;
    }, []);
};

const handleEvent = (eventName: string, params: any) => {
    if (!window.__mmClientApiSubscriptions__) {
        window.__mmClientApiSubscriptions__ = new Map();
    }
    if (!window.__mmClientApiSubscriptions__.get(eventName)) {
        window.__mmClientApiSubscriptions__.set(eventName, []);
    }
    window.__mmClientApiSubscriptions__.get(eventName).push(params);
};

export const initClientApi = (clientAPIEvents: Array<ClientAPIEventNames>, store: Store<AppState, AppActions>) => {
    const handlerByEventName = (eventName: ClientAPIEventNames) => eventHandlerCreators[eventName](store);
    if (window.mmClientApi) {
        getSubscribedEventsInChuncks((window.mmClientApi as Array<any>), 2).forEach(([eventName, params]) => handleEvent(eventName, params));
    }
    window.mmClientApi = {
        push: (eventName: string, params: any) => handleEvent(eventName, params),
    };
    clientAPIEvents.forEach(name => setEventEmitter(name, handlerByEventName(name)));
};
